'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = exports.Row = exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _flexboxgrid = require('flexboxgrid');

var _flexboxgrid2 = _interopRequireDefault(_flexboxgrid);

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

var _Col = require('./Col');

var _Col2 = _interopRequireDefault(_Col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Grid for Enterprise.
 * Has a strong dependency with flexboxgrid <http://flexboxgrid.com/>
 *
 * flexboxgrid must be included in webpack using CSS Modules:
 * {
 *   test: /\.css$/,
 *   loader: 'style!css?modules&localIdentName=[name]__[local]___[hash:base64:5]',
 *   include: /flexboxgrid/
 * },
 *
 * TODO: Extend the possibility to enable the use without CSS Modules
 */
var EnterpriseGrid = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseGrid, _Component);

  function EnterpriseGrid() {
    (0, _classCallCheck3.default)(this, EnterpriseGrid);
    return (0, _possibleConstructorReturn3.default)(this, (EnterpriseGrid.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseGrid)).apply(this, arguments));
  }

  (0, _createClass3.default)(EnterpriseGrid, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          className = _props.className,
          fluid = _props.fluid,
          rest = (0, _objectWithoutProperties3.default)(_props, ['tag', 'children', 'className', 'fluid']);

      var Tag = tag;

      var modifierClasses = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['container-fluid'], _flexboxgrid2.default['container-fluid'] && fluid), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default.container, _flexboxgrid2.default.container && !fluid), _cx));

      return _react2.default.createElement(
        Tag,
        (0, _extends3.default)({}, rest, { className: (0, _classnames2.default)(className, modifierClasses) }),
        children
      );
    }
  }]);
  return EnterpriseGrid;
}(_react.Component), _class.Row = _Row2.default, _class.Col = _Col2.default, _class.propTypes = {
  fluid: _react.PropTypes.bool,
  tag: _react.PropTypes.string,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  tag: 'div'
}, _temp);
exports.default = EnterpriseGrid;
exports.Row = _Row2.default;
exports.Col = _Col2.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseGrid/EnterpriseGrid.jsx
// module id = 1587
// module chunks = 0